// ============== START : Native side cart wiring ==============
// Repoints the Alpine cart store at the native ajax-cart drawer and emits
// `myo:cart.change` after every add/change so listeners can react.
(function () {
  function patchCartStore() {
    if (!window.Alpine || typeof Alpine.store !== 'function') return false;
    var cart = Alpine.store('cart');
    if (!cart) return false;
    cart.openMiniCart = function () { this.cartIsOpen = true; };
    cart.closeMiniCart = function () { this.cartIsOpen = false; };

    if (!cart.__myoChangeWrapped) {
      cart.__myoChangeWrapped = true;
      ['add', 'change'].forEach(function (m) {
        if (typeof cart[m] !== 'function') return;
        var orig = cart[m].bind(cart);
        cart[m] = function () {
          var r = orig.apply(this, arguments);
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('myo:cart.change'));
          }, 350);
          return r;
        };
      });
    }
    return true;
  }
  if (!patchCartStore()) {
    document.addEventListener('alpine:init', patchCartStore);
    document.addEventListener('alpine:initialized', patchCartStore);
    var tries = 0;
    var poll = setInterval(function () {
      if (patchCartStore() || ++tries > 100) clearInterval(poll);
    }, 50);
  }
})();
// ============== END : Native side cart wiring ==============


(function () {
  var ROOT = '.ajax-cart__discount';

  function cartStore() {
    return (window.Alpine && typeof Alpine.store === 'function') ? Alpine.store('cart') : null;
  }

  function currentCodes() {
    return Array.prototype.slice.call(document.querySelectorAll('.ajax-cart__discount-row'))
      .map(function (el) { return (el.getAttribute('data-code') || '').trim(); })
      .filter(Boolean);
  }

  function errorBox() { return document.querySelector('.ajax-cart__discount-error'); }
  function showError(msg) {
    var box = errorBox();
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  }
  function clearError() {
    var box = errorBox();
    if (box) { box.textContent = ''; box.hidden = true; }
  }

  function setBusy(busy) {
    var btn = document.querySelector('.ajax-cart__discount-apply');
    if (!btn) return;
    if (busy) {
      if (!btn.dataset.label) btn.dataset.label = btn.textContent;
      btn.textContent = 'Applying…';
      btn.disabled = true;
    } else {
      if (btn.dataset.label) btn.textContent = btn.dataset.label;
      btn.disabled = false;
    }
  }

  function sameCode(a, b) {
    return (a || '').toLowerCase() === (b || '').toLowerCase();
  }

  function codeIsApplied(html, code) {
    if (!html) return false;
    var attrs = html.match(/data-code="[^"]*"/gi) || [];
    return attrs.some(function (a) { return sameCode(a.slice(11, -1), code); });
  }

  function updateDiscount(codesToKeep, enteredCode) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codesToKeep.join(','), sections: ['ajax-cart'] })
    }).then(function (res) {
      return res.json().then(function (data) { return { status: res.status, data: data }; });
    }).then(function (r) {
      var data = r.data || {};
      var html = data.sections && data.sections['ajax-cart'];
      if (r.status !== 200) { showError('This code is not valid.'); return; }
      if (enteredCode && !codeIsApplied(html, enteredCode)) {
        showError('This code is not valid.');
        return;
      }
      var store = cartStore();
      if (store && typeof store.renderFromResponse === 'function' && html) {
        store.renderFromResponse(html);
      }
    }).catch(function (e) {
      console.error('[native-cart] discount error', e);
      showError('Something went wrong. Please try again.');
    });
  }

  function applyFromInput(input) {
    var code = (input.value || '').trim();
    clearError();
    if (!code) { input.focus(); return; }
    var keep = currentCodes().filter(function (c) { return !sameCode(c, code); });
    keep.push(code);
    setBusy(true);
    updateDiscount(keep, code).then(function () { setBusy(false); }, function () { setBusy(false); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var apply = e.target.closest('.ajax-cart__discount-apply');
    if (apply) {
      var wrap = apply.closest(ROOT);
      var input = wrap && wrap.querySelector('.ajax-cart__discount-input');
      if (input) applyFromInput(input);
      return;
    }
    var remove = e.target.closest('.ajax-cart__discount-remove');
    if (remove) {
      var tag = remove.closest('.ajax-cart__discount-row');
      var code = tag && (tag.getAttribute('data-code') || '').trim();
      clearError();
      var keep = currentCodes().filter(function (c) { return !sameCode(c, code); });
      updateDiscount(keep, null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    var input = e.target.closest('.ajax-cart__discount-input');
    if (!input) return;
    e.preventDefault();
    applyFromInput(input);
  });
})();


/*** BEGIN: Deliver and Assemble ***/
(function() {
const postcodesUrl = '//myomaster.com/cdn/shop/t/110/assets/excluded-build-post-codes.json?v=28302158384697379271792687674';

const DA_NativeCart = {
  _chain: Promise.resolve(),
  _store: function () {
    return (window.Alpine && typeof Alpine.store === 'function') ? Alpine.store('cart') : null;
  },
  _afterWrite: function (data) {
    try {
      var store = DA_NativeCart._store();
      var html = data && data.sections && data.sections['ajax-cart'];
      if (store && html && typeof store.renderFromResponse === 'function') store.renderFromResponse(html);
      if (store && typeof store.getCardItems === 'function') store.getCardItems();
    } catch (e) {}
    return data;
  },
  getItems: function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c && c.items) || []; })
      .catch(function () { return []; });
  },
  _enqueue: function (task) {
    DA_NativeCart._chain = DA_NativeCart._chain.then(task, task);
    return DA_NativeCart._chain;
  },
  addItem: function (variantId, quantity) {
    return DA_NativeCart._enqueue(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1, sections: ['ajax-cart'] })
      }).then(function (r) { return r.json(); }).then(DA_NativeCart._afterWrite).then(function (data) {
        var store = DA_NativeCart._store();
        if (store && typeof store.openMiniCart === 'function') store.openMiniCart();
        return data;
      });
    });
  },
  setQuantity: function (key, quantity) {
    return DA_NativeCart._enqueue(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: ['ajax-cart'] })
      }).then(function (r) { return r.json(); }).then(DA_NativeCart._afterWrite);
    });
  }
};

class DeliverAndAssemble extends HTMLElement {
  static mounted;

  constructor() {
    super();

    fetch(postcodesUrl)
        .then(resp => resp.json())
        .then(data => this.postcodes = data.codes);

  }

  async addMissingBuildProducts() {
    if (this._addingBuildProduct) return;
    this._addingBuildProduct = true;
    try {
      const items = await DA_NativeCart.getItems();
      const presentProductIds = new Set(items.map(item => item.product_id));

      for (const { product_id, build_product_id, build_product_variant } of DeliverAndAssembleCombinations) {
        if (presentProductIds.has(product_id) && !presentProductIds.has(build_product_id)) {
          await DA_NativeCart.addItem(build_product_variant, 1);
        }
      }
    } finally {
      this._addingBuildProduct = false;
    }
  }
  async removeBuildProductsWithMissingMainProduct() {
    const items = await DA_NativeCart.getItems();
    const validMainIds = new Set(items.map(item => item.product_id));

    const comboMap2 = new Map();
    DeliverAndAssembleCombinations.forEach(c => {
      const ids = comboMap2.get(c.build_product_id) || [];
      ids.push(c.product_id);
      comboMap2.set(c.build_product_id, ids);
    });

    for (const item of [...items]) {
        const mainIds = comboMap2.get(item.product_id);

        if (mainIds && !mainIds.some(id => validMainIds.has(id))) {
            await DA_NativeCart.setQuantity(item.key, 0);
        }
    }
  }
  async removeAllBuildProducts() {
    const items = await DA_NativeCart.getItems();
    const buildProductsIds = new Set(DeliverAndAssembleCombinations.map(c => c.build_product_id));

    for (const item of [...items]) {
        if (buildProductsIds.has(item.product_id))
            await DA_NativeCart.setQuantity(item.key, 0);
    }

    // ✅ Reset add flag so user can add again after removing
    this._addingBuildProduct = false;
  }

  async makeSureBuildProductIsOne() {
    const items = await DA_NativeCart.getItems();
    const buildProductsIds = new Set(DeliverAndAssembleCombinations.map(c => c.build_product_id));

    for (const item of [...items]) {
        if (item.quantity > 1 && buildProductsIds.has(item.product_id))
            await DA_NativeCart.setQuantity(item.key, 1);
    }
  }

  checkPostCode() {
    const postcode = this.querySelector('.da-checker-inputs input[type="text"]')?.value;
    const normalized = postcode.trim().toUpperCase();
    
    if (!/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s?(\d[A-Z]{2})$/.test(normalized)) {
      this.querySelector('.da-checker-result').dataset.result = 'regex';
      
      this.querySelectorAll('.da-inputs input').forEach(input => {
        input.setAttribute('disabled', true);
        if (input.value == 'no') {
          input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        }
      });
      return;
    }
    if (!!this.postcodes.some(prefix => normalized.startsWith(prefix))) {
      this.querySelector('.da-checker-result').dataset.result = 'false';
      this.querySelector('.da-checker-result .da-result.da-eligible-false span').innerText = postcode;

      this.querySelectorAll('.da-inputs input').forEach(input => {
        input.setAttribute('disabled', true);
        if (input.value == 'no') {
          input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        }
      });

      return;
    }

    this.querySelector('.da-checker-result').dataset.result = 'true';
    this.querySelectorAll('.da-inputs input').forEach(input => {
      input.disabled = false;
      if (input.value == 'yes') {
        input.checked = true;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }))
      }
    })
  }

  connectedCallback() {

    window.requestAnimationFrame(() => {

        // Guard: only attach listeners once per element instance
        if (this._initialized) return;
        this._initialized = true;

        const state = localStorage.getItem('deliver-and-assemble-state');
        if (state) {
            this.querySelector(`input[value="${state}"]`).checked = true;
        }

        if (this.classList.contains('da-cart')) {
          this.querySelector('.da-title-cart').addEventListener('click', () => {
            this.classList.toggle('da-expanded');
          });
        }
        const button = this.querySelector('.da-checker-inputs button');
        if (button) {
          button.addEventListener('click', () => {
            this.checkPostCode();
          });
        }

        const checkerInputs = this.querySelector('.da-checker-inputs');

        // Open checker when the postcode link span is clicked
        const checkerToggle = this.querySelector('.da-checker-text span');
        if (checkerToggle && checkerInputs) {
          checkerToggle.addEventListener('click', () => {
            checkerInputs.classList.toggle('mm-pdp-checker-open');
          });
        }

        // Main checkbox — show checker on check, hide on uncheck.
        const daCheckbox = this.querySelector('[id^="mm-del-checkbox"]');
        if (daCheckbox && checkerInputs) {
          const syncChecker = () => {
            const yesRadio = this.querySelector('.da-inputs input[value="yes"]');
            const pendingEligibility = !!(yesRadio && yesRadio.disabled && !yesRadio.checked);

            if (pendingEligibility) {
              checkerInputs.classList.add('mm-pdp-checker-open');
              return;
            }

            checkerInputs.classList.toggle('mm-pdp-checker-open', daCheckbox.checked);
            if (!daCheckbox.checked) {
              const resultEl = this.querySelector('.da-checker-result');
              if (resultEl) resultEl.dataset.result = '';
              const noRadio = this.querySelector('input[value="no"]');
              if (noRadio) noRadio.checked = true;
              localStorage.setItem('deliver-and-assemble-state', 'no');
              this.removeAllBuildProducts();
            }
          };
          // 'change' fires after state updates in all modern browsers
          daCheckbox.addEventListener('change', syncChecker);
          // 'click' + rAF as a belt-and-suspenders fallback
          daCheckbox.addEventListener('click', () => requestAnimationFrame(syncChecker));
        }

        this.querySelectorAll('input[type="radio"]').forEach(input => {
            input.addEventListener('change', (e) => {
                
                if (e.target.value == 'yes') {
                    this.addMissingBuildProducts();
                }
                if (e.target.value == 'no') {
                    this.removeAllBuildProducts();
                }

                localStorage.setItem('deliver-and-assemble-state', e.target.value);

                document.dispatchEvent(new CustomEvent('deliver-and-assemble:change', {
                    detail: {
                        value: e.target.value
                    }
                }));
            });
        })
    });

    document.addEventListener('deliver-and-assemble:change', (e) => {
        this.querySelector(`input[type="radio"][value="${e.detail.value}"]`).checked = true;
    });

    if (DeliverAndAssemble.mounted) return;

    DeliverAndAssemble.mounted = true;

    const onCartChange = async () => {
        await this.removeBuildProductsWithMissingMainProduct();

        const daCheckbox = this.querySelector('[id^="mm-del-checkbox"]');
        const radioYes = this.querySelector('input[value="yes"]:checked')?.value == 'yes';
        const optedIn = radioYes && (!daCheckbox || daCheckbox.checked);
        if (!optedIn) return;
        await this.makeSureBuildProductIsOne();
        if (!this._addingBuildProduct) {
          this.addMissingBuildProducts();
        }
    };
    document.addEventListener('myo:cart.change', onCartChange);
  }

  disconnectedCallback() {

  }
}

customElements.define("deliver-and-assemble", DeliverAndAssemble);
})();
/*** END: Deliver and Assemble ***/




